module.exports = __webpack_public_path__ + "img/diagram_third1.5229ea26.svg";